import { useSrpContext } from '@/src/contexts'
import { useLocale, useTranslations } from 'next-intl'

import DestinationInfo from './destinationInfo'

const DestinationInfoWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')
    const locale = useLocale()
    const arrow = locale === 'ar' ? '←' : '→'

    const teaser = sections?.destinationTeaser ?? null
    const legacyInfo = sections?.destination?.info ?? null
    const legacyQuickFacts = sections?.destination?.quickFacts ?? null

    const summary = teaser?.summary ?? legacyInfo?.summary ?? ''
    const title = teaser?.destinationName ?? legacyInfo?.title ?? ''
    const quickFacts = teaser?.quickFacts ?? legacyQuickFacts
    const destinationUrl = teaser?.destinationUrl ?? null
    const rawCta = teaser?.callToAction ?? (title ? t('seeMoreAbout', { city: title }) : '')
    const seeMoreLabel = rawCta ? `${rawCta.replace(/\s*[→←]+$/, '')} ${arrow}` : ''

    if (!summary) return null

    const heading = quickFacts?.country
        ? t('aboutCityCountry', { city: title, country: quickFacts.country })
        : title

    const facts: { label: string; value: string }[] = []
    if (quickFacts) {
        const l = quickFacts.labels
        if (quickFacts.language) facts.push({ label: l?.language ?? t('language'), value: quickFacts.language })
        if (quickFacts.currency) facts.push({ label: l?.currency ?? t('currency'), value: quickFacts.currency })
        if (quickFacts.bestTimeToVisit) facts.push({ label: l?.bestTimeToVisit ?? t('bestTimeToVisitLabel'), value: quickFacts.bestTimeToVisit })
        if (quickFacts.airportName) facts.push({ label: l?.airportName ?? t('airport'), value: `${quickFacts.airportName} (${quickFacts.airportCode})` })
    }

    return (
        <DestinationInfo
            heading={heading}
            overview={summary}
            quickFacts={facts}
            destinationUrl={destinationUrl}
            seeMoreLabel={seeMoreLabel}
        />
    )
}

export default DestinationInfoWrapper
